<template>
  <mm-modal
    title="申请换开发票"
    :visible.sync="visible"
    width="600px"
    :mask-closable="false"
    @close="handleClose"
  >
    <template v-if="loading">
      <div class="loading-wrapper">
        <mm-loading
          size="40px"
          color="#2684FF"
        />
      </div>
    </template>
    <template v-else>
      <mm-tabs
        v-model="activeTab"
        @change="handleTabChange"
      >
        <mm-tab
          v-if="changeBillInfo.support_type_change"
          label="类型调整"
          name="type"
        />
        <mm-tab
          v-if="changeBillInfo.support_title_change"
          label="抬头变更"
          name="header"
        />
      </mm-tabs>

      <div class="change-bill-content">
        <mm-alert
          v-if="invoiceItem.number"
          type="error"
          :closable="false"
          class="change-bill-alert"
        >
          <template #title>
            <ul class="alert-tips">
              <li v-if="activeTab === 'type'">
                仅支持180天内的蓝票重开；
              </li>
              <li v-else>
                仅支持订单未激活情况下进行抬头变更（信用号变更）换票；
              </li>
              <li>
                如果原票（发票号码：{{
                  invoiceItem.number
                }}）已被抵扣，需要联系你公司财务登录税局进行确认红字信息单；
              </li>
              <li v-if="activeTab === 'type'">
                系统将完成原票（发票号码：{{
                  invoiceItem.number
                }}）红冲处理后，根据本次选择的是发票类型重开，不支持更换发票抬头和税号；
              </li>
              <li v-else>
                系统将完成原票（发票号码：{{
                  invoiceItem.number
                }}）红冲处理后，根据本次提交的发票信息重开，请确认信息无误；
              </li>
            </ul>
          </template>
        </mm-alert>

        <ChangeBillTypeForm
          v-show="activeTab === 'type'"
          ref="typeBillForm"
          :form="typeForm"
          :display-info="typeChangeInfo"
        />
        <ChangeBillHeaderForm
          v-show="activeTab === 'header'"
          ref="headerBillForm"
          :form="headerForm"
          :order-id="orderId"
          :display-info="titleChangeInfo"
          :need-payment-proof="changeBillInfo.need_payment_proof"
        />
      </div>
    </template>
    <template #footer>
      <mm-button @click="handleClose">
        取消
      </mm-button>
      <mm-button
        type="primary"
        :loading="submitting"
        @click="handleSubmit"
      >
        提交
      </mm-button>
    </template>
  </mm-modal>
</template>

<script>
import InvoiceApi from "@api/invoice";
import ChangeBillHeaderForm from "./ChangeBillHeaderForm.vue";
import ChangeBillTypeForm from "./ChangeBillTypeForm.vue";
import { Loading } from "amumu-ui";

export default {
  name: "ChangeBillModal",
  components: {
    ChangeBillTypeForm,
    ChangeBillHeaderForm,
    "mm-loading": Loading,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: [String, Number],
      default: "",
    },
    invoiceItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: "type",
      changeBillInfo: {},
      typeForm: {
        invoice_type: null,
      },
      headerForm: {
        invoice_type: null,
        proof_url: "",
      },
      submitting: false,
      loading: false,
    };
  },
  computed: {
    typeChangeInfo() {
      return this.changeBillInfo.type_change_info || {};
    },
    titleChangeInfo() {
      return this.changeBillInfo.title_change_info || {};
    },
  },
  mounted() {
    this.getChangeBillInfo();
  },
  methods: {
    handleTabChange(value) {
      this.activeTab = value;
      this.$nextTick(() => {
        if (this.$refs.headerBillForm) {
          this.$refs.headerBillForm.resetProofState();
        }
      });
    },
    handleClose() {
      this.$emit("close");
    },
    syncFormsFromChangeBillInfo() {
      this.typeForm.invoice_type = this.typeChangeInfo.invoice_type || null;
      this.headerForm.invoice_type = this.titleChangeInfo.invoice_type || null;
    },
    async getChangeBillInfo() {
      this.loading = true;

      try {
        const data = await InvoiceApi.changeBillReopen({
          order_id: this.orderId,
          change_type: 0,
        });

        this.changeBillInfo = data || {};

        if (
          !this.changeBillInfo.support_type_change &&
          this.changeBillInfo.support_title_change
        ) {
          this.activeTab = "header";
        }

        this.syncFormsFromChangeBillInfo();
      } catch (error) {
        // 获取失败由拦截器处理
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      const formRef =
        this.activeTab === "type"
          ? this.$refs.typeBillForm
          : this.$refs.headerBillForm;

      try {
        await formRef.validate();
      } catch (e) {
        return;
      }

      const changeType = this.activeTab === "type" ? 1 : 2;
      const params = {
        order_id: this.orderId,
        change_type: changeType,
        invoice_type:
          this.activeTab === "type"
            ? this.typeForm.invoice_type
            : this.headerForm.invoice_type,
      };

      if (
        this.activeTab === "header" &&
        this.changeBillInfo.need_payment_proof
      ) {
        const isHttpUrl = /http/.test(this.headerForm.proof_url);
        params.remark = isHttpUrl ? this.headerForm.proof_url : `https:${this.headerForm.proof_url}`;
      }

      this.submitting = true;

      try {
        await InvoiceApi.changeBillReopen(params);
        this.$message.success("提交成功");
        this.$emit("close");
      } catch (err) {
        // 提交失败由拦截器处理
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.change-bill-content {
  margin-top: 16px;
}

.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 378px;
}

.change-bill-alert {
  margin-bottom: 20px;

  .alert-tips {
    list-style: disc;
    margin: 0;
    padding-left: 8px;

    li {
      list-style: disc;
      line-height: 1.6;
    }

    li + li {
      margin-top: 6px;
    }
  }
}
</style>
